// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Editor_editor__4NLf4 {
  background: white;
  border-radius: 8px;
  padding: 0;
  max-width: 100%;
}

.Editor_header__0Xgoa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
  border-radius: 8px 8px 0 0;
}

.Editor_title__qe6JR {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0;
}

.Editor_label__Vppht {
  font-weight: 600;
  color: #262626;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Editor_itemColumn__Ck08n {
  margin-bottom: 20px;
}

.Editor_input__Khk45 {
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  transition: all 0.2s ease;
}

.Editor_input__Khk45:hover {
  border-color: #40a9ff;
}

.Editor_input__Khk45:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.Editor_switchContainer__PKAuy {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
}

.Editor_switchLabel__y7eZj {
  font-size: 14px;
  color: #595959;
  font-weight: 500;
}

.Editor_dragHint__mZR1W {
  font-size: 13px;
  color: #7a7a7a;
  margin-bottom: 10px;
}

.Editor_dragList__E0QSO {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.Editor_dragItem__gK2F6 {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 12px;
  cursor: default;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.Editor_dragItem__gK2F6:hover {
  border-color: #40a9ff;
}

.Editor_dragItemDragging__ZNnGY {
  opacity: 0.75;
  background: #f0f7ff;
  border-color: #1890ff;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.22);
}

.Editor_dragIndex__AL-L8 {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #262626;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.Editor_dragBody__ysykk {
  flex: 1 1;
  min-width: 0;
}

.Editor_dragTopRow__uzjix {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.Editor_serviceTopActions__LZtF8 {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.Editor_serviceToggleItem__5ApzR {
  margin-bottom: 0;
}

.Editor_dragTopText__GXmys {
  flex: 1 1;
  min-width: 0;
}

.Editor_serviceConfigGrid__6HEP7 {
  margin-top: 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

.Editor_dispatchOrderItem__2LSUf .ant-form-item-control {
  width: 100%;
  max-width: 100%;
}

.Editor_dispatchOrderItem__2LSUf .ant-form-item-control-input {
  width: 100%;
}

.Editor_dispatchOrderItem__2LSUf .ant-form-item-control-input-content {
  width: 100%;
}

.Editor_serviceField__DoSpa {
  margin-bottom: 0;
}

.Editor_serviceFieldCompact__nbHLD {
  flex: 1 1;
  margin-bottom: 0;
  min-width: 0;
}

.Editor_fieldLabel__RQd\\+Z {
  font-size: 11px;
  font-weight: 600;
  color: #595959;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.Editor_pricingInputs__5vehW {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}

.Editor_pricingField__u88Q9 {
  min-width: 0;
}

.Editor_pricingFieldLabel__-wMNY {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #595959;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.Editor_dragTitle__UcyBd {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  line-height: 1.2;
}

.Editor_dragSubtitle__b88zC {
  margin-top: 2px;
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.2;
}

.Editor_dragHandle__fzOgH {
  font-size: 16px;
  color: #8c8c8c;
  flex-shrink: 0;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, transform 0.2s;
}

.Editor_dragHandle__fzOgH:hover {
  color: #1890ff;
  transform: scale(1.2);
}

.Editor_dragHandle__fzOgH:active {
  cursor: grabbing;
  color: #096dd9;
}

.Editor_dragItemDragOver__tRFdm {
  background-color: #e6f7ff !important;
  border-color: #1890ff !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.Editor_itemSubmit__1c46Y {
  margin-top: 30px;
  margin-bottom: 0;
}

.Editor_submit__aZilH {
  width: 100%;
  height: 48px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.Editor_submit__aZilH:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

/* Form styling */

.Editor_ant-form-item-label__BPZt- > label {
  height: auto;
  line-height: 1.4;
}

.Editor_ant-form-item-label__BPZt- {
  padding-bottom: 8px;
}

.Editor_ant-input__4Ivt0,
.Editor_ant-input-affix-wrapper__W9eJM {
  border-radius: 6px;
}

.Editor_ant-input__4Ivt0:focus,
.Editor_ant-input-affix-wrapper__W9eJM:focus,
.Editor_ant-input-focused__8S3Kz,
.Editor_ant-input-affix-wrapper-focused__Zi7hX {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* Responsive */

@media (max-width: 768px) {
  .Editor_editor__4NLf4 {
    margin: 0;
  }

  .Editor_header__0Xgoa {
    padding: 16px 20px;
  }

  .Editor_title__qe6JR {
    font-size: 16px;
  }

  .Editor_itemColumn__Ck08n {
    margin-bottom: 16px;
  }

  .Editor_pricingInputs__5vehW {
    grid-template-columns: minmax(0, 1fr);
  }

  .Editor_submit__aZilH {
    height: 44px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/areas/styles/Editor.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,iBAAiB;;AACjB;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,eAAe;;AACf;EACE;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".editor {\n  background: white;\n  border-radius: 8px;\n  padding: 0;\n  max-width: 100%;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #f0f0f0;\n  background-color: #fafafa;\n  border-radius: 8px 8px 0 0;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #262626;\n  margin: 0;\n}\n\n.label {\n  font-weight: 600;\n  color: #262626;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.itemColumn {\n  margin-bottom: 20px;\n}\n\n.input {\n  border-radius: 6px;\n  border: 1px solid #d9d9d9;\n  transition: all 0.2s ease;\n}\n\n.input:hover {\n  border-color: #40a9ff;\n}\n\n.input:focus {\n  border-color: #40a9ff;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n}\n\n.switchContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n}\n\n.switchLabel {\n  font-size: 14px;\n  color: #595959;\n  font-weight: 500;\n}\n\n.dragHint {\n  font-size: 13px;\n  color: #7a7a7a;\n  margin-bottom: 10px;\n}\n\n.dragList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.dragItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: #ffffff;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  padding: 12px;\n  cursor: default;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.dragItem:hover {\n  border-color: #40a9ff;\n}\n\n.dragItemDragging {\n  opacity: 0.75;\n  background: #f0f7ff;\n  border-color: #1890ff;\n  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.22);\n}\n\n.dragIndex {\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  color: #262626;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.dragBody {\n  flex: 1;\n  min-width: 0;\n}\n\n.dragTopRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.serviceTopActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.serviceToggleItem {\n  margin-bottom: 0;\n}\n\n.dragTopText {\n  flex: 1;\n  min-width: 0;\n}\n\n.serviceConfigGrid {\n  margin-top: 12px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 10px;\n}\n\n.dispatchOrderItem :global(.ant-form-item-control) {\n  width: 100%;\n  max-width: 100%;\n}\n\n.dispatchOrderItem :global(.ant-form-item-control-input) {\n  width: 100%;\n}\n\n.dispatchOrderItem :global(.ant-form-item-control-input-content) {\n  width: 100%;\n}\n\n.serviceField {\n  margin-bottom: 0;\n}\n\n.serviceFieldCompact {\n  flex: 1;\n  margin-bottom: 0;\n  min-width: 0;\n}\n\n.fieldLabel {\n  font-size: 11px;\n  font-weight: 600;\n  color: #595959;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n}\n\n.pricingInputs {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n}\n\n.pricingField {\n  min-width: 0;\n}\n\n.pricingFieldLabel {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color: #595959;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.dragTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #262626;\n  line-height: 1.2;\n}\n\n.dragSubtitle {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #8c8c8c;\n  line-height: 1.2;\n}\n\n.dragHandle {\n  font-size: 16px;\n  color: #8c8c8c;\n  flex-shrink: 0;\n  white-space: nowrap;\n  user-select: none;\n  cursor: grab;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s, transform 0.2s;\n}\n\n.dragHandle:hover {\n  color: #1890ff;\n  transform: scale(1.2);\n}\n\n.dragHandle:active {\n  cursor: grabbing;\n  color: #096dd9;\n}\n\n.dragItemDragOver {\n  background-color: #e6f7ff !important;\n  border-color: #1890ff !important;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n}\n\n.itemSubmit {\n  margin-top: 30px;\n  margin-bottom: 0;\n}\n\n.submit {\n  width: 100%;\n  height: 48px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.2s ease;\n}\n\n.submit:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);\n}\n\n/* Form styling */\n.ant-form-item-label > label {\n  height: auto;\n  line-height: 1.4;\n}\n\n.ant-form-item-label {\n  padding-bottom: 8px;\n}\n\n.ant-input,\n.ant-input-affix-wrapper {\n  border-radius: 6px;\n}\n\n.ant-input:focus,\n.ant-input-affix-wrapper:focus,\n.ant-input-focused,\n.ant-input-affix-wrapper-focused {\n  border-color: #40a9ff;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .editor {\n    margin: 0;\n  }\n  \n  .header {\n    padding: 16px 20px;\n  }\n  \n  .title {\n    font-size: 16px;\n  }\n  \n  .itemColumn {\n    margin-bottom: 16px;\n  }\n\n  .pricingInputs {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  \n  .submit {\n    height: 44px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `Editor_editor__4NLf4`,
	"header": `Editor_header__0Xgoa`,
	"title": `Editor_title__qe6JR`,
	"label": `Editor_label__Vppht`,
	"itemColumn": `Editor_itemColumn__Ck08n`,
	"input": `Editor_input__Khk45`,
	"switchContainer": `Editor_switchContainer__PKAuy`,
	"switchLabel": `Editor_switchLabel__y7eZj`,
	"dragHint": `Editor_dragHint__mZR1W`,
	"dragList": `Editor_dragList__E0QSO`,
	"dragItem": `Editor_dragItem__gK2F6`,
	"dragItemDragging": `Editor_dragItemDragging__ZNnGY`,
	"dragIndex": `Editor_dragIndex__AL-L8`,
	"dragBody": `Editor_dragBody__ysykk`,
	"dragTopRow": `Editor_dragTopRow__uzjix`,
	"serviceTopActions": `Editor_serviceTopActions__LZtF8`,
	"serviceToggleItem": `Editor_serviceToggleItem__5ApzR`,
	"dragTopText": `Editor_dragTopText__GXmys`,
	"serviceConfigGrid": `Editor_serviceConfigGrid__6HEP7`,
	"dispatchOrderItem": `Editor_dispatchOrderItem__2LSUf`,
	"serviceField": `Editor_serviceField__DoSpa`,
	"serviceFieldCompact": `Editor_serviceFieldCompact__nbHLD`,
	"fieldLabel": `Editor_fieldLabel__RQd+Z`,
	"pricingInputs": `Editor_pricingInputs__5vehW`,
	"pricingField": `Editor_pricingField__u88Q9`,
	"pricingFieldLabel": `Editor_pricingFieldLabel__-wMNY`,
	"dragTitle": `Editor_dragTitle__UcyBd`,
	"dragSubtitle": `Editor_dragSubtitle__b88zC`,
	"dragHandle": `Editor_dragHandle__fzOgH`,
	"dragItemDragOver": `Editor_dragItemDragOver__tRFdm`,
	"itemSubmit": `Editor_itemSubmit__1c46Y`,
	"submit": `Editor_submit__aZilH`,
	"ant-form-item-label": `Editor_ant-form-item-label__BPZt-`,
	"ant-input": `Editor_ant-input__4Ivt0`,
	"ant-input-affix-wrapper": `Editor_ant-input-affix-wrapper__W9eJM`,
	"ant-input-focused": `Editor_ant-input-focused__8S3Kz`,
	"ant-input-affix-wrapper-focused": `Editor_ant-input-affix-wrapper-focused__Zi7hX`
};
export default ___CSS_LOADER_EXPORT___;
